/**
 * CUSTOM FIELDS — enhancements 3 and 4, one mechanism. A value collected at a
 * project, deliverable, task or task stage, seen and changed by an audience
 * that may be narrower than everyone.
 */
/** How an audience reads on screen — the workbook's own words. */
export const FIELD_AUDIENCE_LABELS = {
    everyone: "everyone",
    holders: "stage holders",
    owner_and_holders: "task owner + stage holders",
    pms_and_admins: "PMs + admins",
    admins: "admins",
};
//# sourceMappingURL=fields.js.map